import type { Keg } from "types"
import { calculateCostLeft } from "./calculateCostLeft"
import { getKegFillLevel } from "./getKegFillLevel"

export const getCostLeftFromKeg = (keg: Keg) => +calculateCostLeft(keg.cost, getKegFillLevel(keg))
